var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.49984H2.01279M2.01279 4.49984H13.9873M2.01279 4.49984C2 4.70942 2 4.96778 2 5.29997V11.7C2 12.4467 2 12.8195 2.14532 13.1048C2.27316 13.3556 2.47698 13.5602 2.72786 13.688C3.0128 13.8332 3.386 13.8332 4.13129 13.8332L11.8687 13.8332C12.614 13.8332 12.9867 13.8332 13.2716 13.688C13.5225 13.5602 13.727 13.3556 13.8548 13.1048C14 12.8198 14 12.4472 14 11.7019L14 5.29778C14 4.96664 14 4.70896 13.9873 4.49984M2.01279 4.49984C2.02876 4.23829 2.06465 4.0527 2.14532 3.89437C2.27316 3.64349 2.47698 3.43966 2.72786 3.31183C3.01308 3.1665 3.38673 3.1665 4.13346 3.1665H11.8668C12.6135 3.1665 12.9864 3.1665 13.2716 3.31183C13.5225 3.43966 13.727 3.64349 13.8548 3.89437C13.9355 4.0527 13.9713 4.23829 13.9873 4.49984M13.9873 4.49984H14",
    stroke: "#404252",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorSizeIcon);
export default __webpack_public_path__ + "static/media/FloorSizeIcon.81f2b3ece2a45dd8272e5626ef9aca50.svg";
export { ForwardRef as ReactComponent };